/* src/app/module/service-advisors/add-service-advisor/service-advisor-resume/service-advisor-resume.component.scss */
.form-container {
  margin: 0 auto;
  background: #ffffff;
  border-radius: 10px;
}
.custom-upload-button {
  border: none;
  padding: 10px 16px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease, transform 0.3s ease;
}
.custom-upload-button:disabled {
  background-color: #FFD9AA;
  cursor: not-allowed;
}
.custom-upload-button .arrow {
  margin-left: 8px;
  font-size: 16px;
  transition: margin-left 0.3s ease;
}
.custom-upload-button:hover:not(:disabled) .arrow {
  margin-left: 12px;
}
.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 43px;
}
.remove-button {
  background: none;
  border: none;
  color: red;
  cursor: pointer;
  font-size: 14px;
}
::ng-deep .ng-invalid.ng-touched {
  border-color: darkred !important;
  box-shadow: none !important;
}
::ng-deep .p-inputtext.ng-invalid.ng-touched,
::ng-deep .p-dropdown.ng-invalid.ng-touched .p-dropdown-label,
::ng-deep .p-dropdown.ng-invalid.ng-touched .p-dropdown-trigger {
  border-color: darkred !important;
  background-color: #ffe6e6 !important;
}
::ng-deep .field-wrapper.ng-invalid.ng-touched .p-inputtext,
::ng-deep .field-wrapper.ng-invalid.ng-touched .p-dropdown {
  border-color: darkred !important;
  background-color: #ffe6e6 !important;
}
::ng-deep .formly-validation-message {
  color: darkred;
  font-weight: bold;
}
::ng-deep label {
  color: var(--Gray-700, #344054);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
}
::ng-deep .placeholder {
  color: #667085;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
}
::ng-deep .p-dropdown {
  margin-top: 8px;
}
::ng-deep input {
  margin-top: 8px;
}
form {
  margin-right: 30px;
}
/*# sourceMappingURL=service-advisor-resume.component-XAV7FX2J.css.map */
